/*
* Broadcast Theme
* Custom Javascript
*/

(function() {
  'use strict';

  function initMobileProductSlider() {
    const productImagesContainers = document.querySelectorAll('product-images');
    if (!productImagesContainers.length) return;

    productImagesContainers.forEach((container) => {
      if (container._yonderSliderInitialized) return;
      container._yonderSliderInitialized = true;

      const mediaList = container.querySelector('[data-product-media-list]');
      if (!mediaList) return;

      const slides = Array.from(mediaList.querySelectorAll('.product__slide'));
      if (slides.length < 2) return;

      const thumbsHolder = container.parentElement?.querySelector('.product__thumbs') || container.querySelector('.product__thumbs');
      const thumbItems = thumbsHolder ? Array.from(thumbsHolder.querySelectorAll('[data-thumb-item]')) : [];

      // Update active dot based on scroll position
      const updateActiveDot = () => {
        const slideWidth = mediaList.offsetWidth;
        if (!slideWidth) return;
        const activeIndex = Math.min(Math.max(Math.round(mediaList.scrollLeft / slideWidth), 0), slides.length - 1);
        if (thumbItems.length) {
          thumbItems.forEach((thumb, idx) => {
            thumb.classList.toggle('is-active', idx === activeIndex);
          });
        }
      };

      // Native scroll listener for touch scroll-snap & dot sync
      let scrollTimer = null;
      let isDragging = false;
      mediaList.addEventListener('scroll', () => {
        if (isDragging) return;
        cancelAnimationFrame(scrollTimer);
        scrollTimer = requestAnimationFrame(updateActiveDot);
      }, { passive: true });

      // Click on dot scrolls slider to that slide
      if (thumbsHolder) {
        thumbItems.forEach((thumb, idx) => {
          thumb.addEventListener('click', (e) => {
            e.preventDefault();
            if (slides[idx]) {
              mediaList.scrollTo({
                left: slides[idx].offsetLeft,
                behavior: 'smooth'
              });
              thumbItems.forEach((t, i) => t.classList.toggle('is-active', i === idx));
            }
          });
        });
      }

      // Interactive mouse & touch drag-to-scroll
      let isDown = false;
      let startX = 0;
      let startScrollLeft = 0;
      let dragStartTime = 0;

      const onStart = (pageX) => {
        if (window.innerWidth >= 750) return;
        isDown = true;
        isDragging = false;
        startX = pageX;
        startScrollLeft = mediaList.scrollLeft;
        dragStartTime = Date.now();
        mediaList.style.scrollBehavior = 'auto';
        mediaList.style.scrollSnapType = 'none';
      };

      const onMove = (pageX, e) => {
        if (!isDown) return;
        const diffX = pageX - startX;
        if (Math.abs(diffX) > 5) {
          isDragging = true;
          mediaList.classList.add('is-dragging');
          if (e && e.cancelable) e.preventDefault();
        }
        mediaList.scrollLeft = startScrollLeft - diffX;
        updateActiveDot();
      };

      const onEnd = (pageX) => {
        if (!isDown) return;
        isDown = false;
        mediaList.classList.remove('is-dragging');
        mediaList.style.scrollBehavior = 'smooth';
        mediaList.style.scrollSnapType = 'x mandatory';

        const diffX = pageX - startX;
        const dragDuration = Date.now() - dragStartTime;
        const slideWidth = mediaList.offsetWidth || 1;
        const currentIndex = Math.round(startScrollLeft / slideWidth);

        // Quick flick (>30px in <300ms) or distance > 25% slide width
        let targetIndex = currentIndex;
        if (diffX < -30 && (dragDuration < 300 || Math.abs(diffX) > slideWidth * 0.25)) {
          targetIndex = Math.min(currentIndex + 1, slides.length - 1);
        } else if (diffX > 30 && (dragDuration < 300 || Math.abs(diffX) > slideWidth * 0.25)) {
          targetIndex = Math.max(currentIndex - 1, 0);
        } else {
          targetIndex = Math.min(Math.max(Math.round(mediaList.scrollLeft / slideWidth), 0), slides.length - 1);
        }

        if (slides[targetIndex]) {
          mediaList.scrollTo({
            left: slides[targetIndex].offsetLeft,
            behavior: 'smooth'
          });
        }
        updateActiveDot();

        setTimeout(() => {
          isDragging = false;
        }, 50);
      };

      // Mouse drag listeners (enables click-and-drag in desktop/dev tools)
      mediaList.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        onStart(e.pageX);
      });

      window.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        onMove(e.pageX, e);
      });

      window.addEventListener('mouseup', (e) => {
        if (!isDown) return;
        onEnd(e.pageX);
      });

      // Prevent accidental link/image clicks during drag
      mediaList.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileProductSlider);
  } else {
    initMobileProductSlider();
  }

  document.addEventListener('shopify:section:load', initMobileProductSlider);

  // Video Click to Play (play button or background hero__content__wrapper)
  document.addEventListener('click', function(e) {
    var playBtn = e.target.closest('[data-video-inline-play-btn]');
    var contentWrapper = e.target.closest('[data-video-content-wrapper]');
    var inlineContainer = e.target.closest('[data-video-inline-container]');
    var heroVideo = e.target.closest('.hero__video');

    var trigger = playBtn || contentWrapper || inlineContainer || heroVideo;
    if (!trigger) return;

    var frame = trigger.closest('.frame');
    if (!frame) return;

    var holder = frame.querySelector('[data-video-inline-holder]');
    var video = frame.querySelector('.video-inline-element');
    var iframe = frame.querySelector('.video-inline-iframe');
    var frameHeroVideo = frame.querySelector('.hero__video');
    var wrapper = frame.querySelector('[data-video-content-wrapper]');

    // Inline video mode
    if (holder && frameHeroVideo) {
      // If already playing, do nothing
      if (frameHeroVideo.classList.contains('is-playing')) return;

      // Don't intercept actual navigation link buttons
      var navLink = e.target.closest('a');
      if (navLink && navLink.getAttribute('href') && navLink.getAttribute('href') !== '#' && !navLink.closest('[data-video-inline-play-btn]')) {
        return;
      }

      e.preventDefault();

      holder.style.display = 'block';
      frameHeroVideo.classList.add('is-playing');
      if (wrapper) {
        wrapper.classList.add('is-playing');
      }

      if (video) {
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(function() {
            video.muted = true;
            video.play();
          });
        }
      } else if (iframe && iframe.getAttribute('data-src')) {
        var src = iframe.getAttribute('data-src');
        if (!iframe.src || iframe.src === '' || iframe.src === window.location.href) {
          iframe.src = src;
        }
      }
    } else {
      // Popup video mode: clicking background, wrapper or poster opens popup
      var popupBtn = frame.querySelector('video-popup [data-video-play]');
      if (popupBtn) {
        var navLink = e.target.closest('a');
        if (navLink && !navLink.closest('video-popup')) return;

        if (!e.target.closest('video-popup')) {
          e.preventDefault();
          popupBtn.click();
        }
      }
    }
  });

  // Video Click-to-Play/Pause on video body (above controls bar)
  document.addEventListener('click', function(e) {
    var video = e.target.closest('.video-inline-element');
    if (!video) return;

    var rect = video.getBoundingClientRect();
    // Allow native controls clicks in bottom 52px
    if (e.clientY <= rect.bottom - 52) {
      e.preventDefault();
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }
  });

  // Video Popup Click-to-Close on backdrop
  document.addEventListener('click', function(e) {
    var pswp = e.target.closest('.pswp--video');
    if (!pswp) return;

    // Ignore if clicked on video player itself, iframe, controls, or buttons
    if (e.target.closest('video, iframe, .pswp__custom-iframe, .pswp__custom-iframe-outer, .pswp__button, .pswp__custom-close')) return;

    var closeBtn = pswp.querySelector('.pswp__custom-close') || pswp.querySelector('.pswp__button--close');
    if (closeBtn) {
      closeBtn.click();
    }
  });

  // Product text badge: hide on swipe on mobile/touch, show only on 1st image
  document.addEventListener('scroll', function(e) {
    var slider = e.target;
    if (!slider || !slider.hasAttribute || !slider.hasAttribute('data-hover-slider')) return;
    var container = slider.closest('[data-product-image]') || slider.closest('.product-item');
    if (container) {
      container.classList.toggle('is-swiped', slider.scrollLeft > 10);
    }
  }, true);
})();
